import React, { createContext, useContext, useMemo } from 'react';

export interface EmbedRuntimeConfig {
  tenant: string;
  hideChrome?: boolean;
  initialRoute?: string;
  onRouteChange?: (path: string) => void;
  onCheckoutComplete?: (confirmId: string) => void;
}

const EmbedContext = createContext<EmbedRuntimeConfig | null>(null);

export const EmbedProvider = ({
  config,
  children,
}: React.PropsWithChildren<{ config: EmbedRuntimeConfig }>) => {
  const value = useMemo(() => config, [config]);

  return <EmbedContext.Provider value={value}>{children}</EmbedContext.Provider>;
};

export const useEmbedConfig = () => {
  const context = useContext(EmbedContext);
  return context;
};

export const useIsEmbedMode = () => Boolean(useEmbedConfig());

export default EmbedContext;
